import isPortalSpecificObjectType from 'customer-data-objects/crmObject/isPortalSpecificObjectType';
export const getObjectTypeForLogging = objectTypeId => isPortalSpecificObjectType(objectTypeId) ? 'custom' : objectTypeId;